"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRightPane = useRightPane;
const RightPaneContext_1 = require("./RightPaneContext");
function useRightPane() {
    const { openInPane, closePane } = (0, RightPaneContext_1.useRightPaneContext)();
    return {
        openRightPane: openInPane,
        closeRightPane: closePane,
    };
}
